module.exports = __webpack_public_path__ + "assets/img/img-11.41ad097c.png";